export { default } from "./WritePromptConfirmationScreen";
